/// <reference types="./vite-env.d.ts" />
import React from 'react'
import ReactDOM from 'react-dom/client'

import { startMocking } from './msw/browser'
import App from './App'

// Start MSW if enabled
startMocking().then(() => {
  // NOSONAR
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
})
